import { useCallback, useEffect } from "react";
import { useService } from "../../../../hooks";

export const useGuestCarQueryModal = () => {
  const { openModal, closeModal } = useService("Misc");

  useEffect(() => {
    openModal("first-time-modal");
  }, [openModal]);

  const closeFirstTimeModal = useCallback(
    () => closeModal("first-time-modal"),
    [closeModal]
  );

  const openCarSelectModal = useCallback(() => {
    closeFirstTimeModal();
    openModal("car-select-modal");
  }, [closeFirstTimeModal, openModal]);
  return {
    openCarSelectModal,
    closeFirstTimeModal,
  };
};
